import React, { useState } from 'react';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import InputField from '../../../components/form/InputField';
import SubmitButton from '../../../components/form/SubmitButton';
import LoadingButton from '../../../components/form/LoadingButton';
import { apiPost } from '../../../utils/api';
import { showError, showSuccess } from '../../../utils/alert';
import { useDispatch } from 'react-redux';
import { loginAdmin } from '../../../redux/adminSlice';
import { useLocation, useNavigate } from 'react-router-dom';

interface LoginFormData {
  email: string;
  password: string;
}

export default function AdminLoginPage() {
  const { t } = useTranslation();
  const { handleSubmit, register, formState: { errors } } = useForm<LoginFormData>();
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const onSubmit = async (data: LoginFormData) => {
    try {
      setLoading(true);
      const response = await apiPost('admin/login', data) as { token: string };
      showSuccess(t("loginAdminSuccess"));
      // dispatch(loginAdmin({ token: response.token }));

      // ✅ بعد تسجيل الدخول، رجّع المستخدم إلى الصفحة اللي كان فيها
      const params = new URLSearchParams(location.search);
      const redirect = params.get("redirect");
      navigate(redirect || "/admin/dashboard", { replace: true });

      setLoading(false);
    } catch (err: any) {
      setLoading(false);
      showError(err.message);
    }
  };

  return (
    <div className="min-h-screen w-screen flex flex-col md:flex-row bg-light overflow-hidden">
      {/* Image Section */}
      <div className="hidden md:block md:w-1/2 h-screen">
        <img
          src={"/main.png"}
          alt="Login"
          className="w-full h-full object-cover"
        />
      </div>

      {/* Form Section */}
      <div className="flex flex-1 justify-center items-center p-8 md:p-16 min-h-screen">
        <div className="w-full max-w-md p-6 md:p-8">
          {/* Title */}
          <h1 className="text-2xl text-center font-bold text-Black mb-8 capitalize">
            {t('admin_login_title')}
          </h1>

          {/* Form */}
          <form onSubmit={handleSubmit(onSubmit)} className="flex flex-col gap-4">
            <InputField
              placeholder={t('emailPlaceholder')}
              register={register('email', { 
                required: t('owner.emailRequired'),
                pattern: { value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/, message: t('owner.emailInvalid') }
              })}
              error={errors.email}
              type="email"
            />

            <InputField
              placeholder={t('passwordPlaceholder')}
              type="password"
              register={register('password', { required: t('passwordRequired') })}
              error={errors.password}
            />

            {loading
              ? <LoadingButton height={64} />
              : <SubmitButton height={64} label={('login_btn')} />
            }
          </form>
        </div>
      </div>
    </div>
  );
}
